module.exports = __webpack_public_path__ + "static/img/download.8cda627.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footer_header/download.png
// module id = aAYD
// module chunks = 6